export const BUSINESS_DIRECTION = {
  SERVICE: "SERVICE",
  PRODUCT: "PRODUCT",
};


export const DIRECTION_MAPPING = {
  SERVICE_TYPE: BUSINESS_DIRECTION.SERVICE,
  PRODUCT_TYPE: BUSINESS_DIRECTION.PRODUCT,
};

/**

 * @param {Object} profile 
 * @returns {Object}
 */
export const transformProfileForBackend = (profile) => {
  return {
    ...profile,

    direction: DIRECTION_MAPPING[profile.direction] || profile.direction,

    sellChannels:
      Array.isArray(profile.sellChannels) && profile.sellChannels.length > 0
        ? profile.sellChannels[0]
        : profile.sellChannels,
  };
};